<template>
  <div class="search-by-cabin">
    <filters-button
      v-for="(option, index) in cabin_options"
      :key="`${option}:cabin_options:${index}`"
      :text="option.text"
      :active="cabin === option.value"
      @click="() => handle_change(option.value)"
    >
    </filters-button>
  </div>
</template>

<script>
import FiltersButton from "./filters-button.vue";

export default {
  name: "search-by-cabin",
  components: {
    "filters-button": FiltersButton,
  },
  created() {
    document.body.classList.remove("overflow-hidden");
  },
  computed: {
    cabin: {
      get() {
        return this.$store.state.liveflight.cabin || "";
      },
      set(value) {
        this.$store.commit("liveflight/cabin", value);
      },
    },
  },
  data() {
    return {
      cabin_options: [
        {
          value: "",
          text: "Tutte",
        },
        {
          value: "ECONOMY",
          text: "Economy",
        },
        {
          value: "PREMIUM_ECONOMY",
          text: "Premium economy",
        },
        {
          value: "BUSINESS",
          text: "Business",
        },
        {
          value: "FIRST",
          text: "First",
        },
      ],
    };
  },
  methods: {
    handle_change(value) {
      this.cabin = value
      //this.log('[CHANGE]: cabin = '+this.cabin)
      window.eventBus.$emit("change-search-by", { cabin: value });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-by-cabin {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
